import { infiniteQueryOptions, QueryObserverOptions, queryOptions } from "@tanstack/react-query";
import { followRobot, getHashtags, getRobotoCategories, getRobotoList, recommendRobot, searchCreator, searchGroup, searchRoboto } from "../home";
import { filtersToKey, filtersToRequestParams, SearchFilters } from "@/app/[locale]/(layout)/(home)/_util/searchFilter";

type OtherQueryOption = Omit<QueryObserverOptions, 'queryKey' | 'queryFn'>


export const homeRobotQueryOption = ({
  locale = 'en',
  categories = [],
}
) => infiniteQueryOptions({
  queryKey: [
    'robots',
    'index',
    locale,
    categories[0] === undefined ? '' : categories[0]
  ],

  initialPageParam: { limit: 50, page: 1 },
  queryFn: async ({ pageParam }) => {
    if (categories[0] === 0) {
      const res = await followRobot({
        ...pageParam, sortBy: "chat_num", stype: "name",
        categories: categories[0]
      })
      return res.data
    }
    const res = await getRobotoList({
      ...pageParam,
      locale,
      categories: categories[0]
    })
    return res
  },
  getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
    if (!lastPage?.data || lastPage?.data?.length === 0) return null
    return { limit: 50, page: lastPageParam.page! + 1 }
  },
  staleTime: Infinity,
})


// 搜索页面机器人
export const searchRobotQueryOption = ({ keyword, categories = [], filters }: {
  keyword: string
  categories?: any[]
  filters?: SearchFilters
}) => {
  const filterParams = filters ? filtersToRequestParams(filters) : {}
  return infiniteQueryOptions({
    queryKey: ['search', 'robot', keyword, categories[0] || '', filters ? filtersToKey(filters) : ''],
    initialPageParam: { limit: 40, page: 1 },
    queryFn: async ({ pageParam }) => {
      const res = await searchRoboto({
        ...pageParam,
        keyword,
        categories: categories[0],
        ...filterParams,
      }, { cache: "no-store" })
      return res.data
    },
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (!lastPage?.data || lastPage?.data?.length === 0) return null
      return { ...lastPageParam, page: lastPageParam.page! + 1 }
    },
    staleTime: Infinity,
  })
}

// 搜索群组（不缓存，按 tab 激活时再拉）
export const searchGroupQueryOption = ({ keyword, enabled = true }: { keyword: string, enabled?: boolean }) =>
  infiniteQueryOptions({
    queryKey: ['search', 'group', keyword],
    initialPageParam: { limit: 30, page: 1 },
    queryFn: async ({ pageParam }) => {
      const res = await searchGroup({ ...pageParam, keyword }, { cache: 'no-store' })
      const list = Array.isArray(res.data) ? res.data : (res.data?.data ?? [])
      return { data: list }
    },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (!lastPage?.data || lastPage.data.length === 0) return null
      return { ...lastPageParam, page: lastPageParam.page! + 1 }
    },
    staleTime: Infinity,
    enabled,
  })

// 搜索创作者/作者（不缓存）
export const searchCreatorQueryOption = ({ keyword, enabled = true }: { keyword: string, enabled?: boolean }) =>
  infiniteQueryOptions({
    queryKey: ['search', 'creator', keyword],
    initialPageParam: { limit: 30, page: 1 },
    queryFn: async ({ pageParam }) => {
      const res = await searchCreator({ ...pageParam, name: keyword }, { cache: 'no-store' })
      const list = Array.isArray(res.data) ? res.data : (res.data?.data ?? [])
      return { data: list }
    },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (!lastPage?.data || lastPage.data.length === 0) return null
      return { ...lastPageParam, page: lastPageParam.page! + 1 }
    },
    staleTime: Infinity,
    enabled,
  })

export const homeCategoriesQueryOption = ({ locale = 'en' }, option: OtherQueryOption = {}) => {
  return queryOptions({
    queryKey: ['category', locale],
    queryFn: () => getRobotoCategories({ status: 1, order: 'asc', sort: "sequence", }, { cache: "force-cache", next: { revalidate: 60 * 60 } }),
    staleTime: Infinity,
    ...option,
  })
}

export const RecommendRobot = queryOptions({
  queryKey: ['recommend', 'robot'],
  queryFn: () => recommendRobot(),
})

export const HashtagQueryOption = queryOptions({
  queryKey: ['hashtag'],
  queryFn: getHashtags,
  staleTime: Infinity,

})